module.exports = __webpack_public_path__ + "static/invoker-03-859d6da47b6f8b2dc003dc14813e4ea7.png";